import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import { AuthorizationForm } from 'api/admin/authorization';
import { StringField } from 'components/shared/form/input';
import ThemedButton from 'components/shared/themed_button';
import Logo from 'images/logo.png';
import { Form } from 'rac';
import React from 'react';

type LoginFormProps = {
  form: Form<AuthorizationForm>;
  handleClick: () => void;
  passwordResetUrl?: string;
};
const LoginForm: React.FC<LoginFormProps> = (props) => {
  return (
    <Paper className="login-area">
      <div style={{ textAlign: 'center', width: '100%', marginBottom: 20 }}>
        <img src={Logo} alt="reprua-logo" style={{ objectFit: 'contain', width: 200 }} />
        <p style={{ fontWeight: 'bold' }}>機器管理</p>
      </div>
      <form className="login-form">
        <div>
          <StringField
            form={props.form}
            attr="email"
            className="email"
            label="メールアドレス"
            data-test="email-input"
          />
        </div>
        <div>
          <StringField
            form={props.form}
            attr="password"
            className="password"
            label="パスワード"
            type="password"
            data-test="password-input"
          />
        </div>
        <div style={{ textAlign: 'right' }}>
          <ThemedButton
            color="primary"
            onClick={() => {
              props.handleClick();
            }}
            data-test="login-button"
          >
            ログイン
          </ThemedButton>
        </div>
      </form>
      {props.passwordResetUrl && (
        <>
          <Divider style={{ marginTop: 20 }} />
          <div style={{ textAlign: 'center', marginTop: 10 }}>
            <Link href={props.passwordResetUrl} rel="noopener noreferrer" underline="hover" sx={{ fontSize: 14 }}>
              パスワードをお忘れの方
            </Link>
          </div>
        </>
      )}
    </Paper>
  );
};

export default LoginForm;
